/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./cup-logo.vue?vue&type=template&id=2f821b1c&"
import script from "./cup-logo.vue?vue&type=script&lang=js&"
export * from "./cup-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports